import dedent from 'dedent';
import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'read-reference-file' as const;

const argumentZod = z.object({
  name: z
    .string()
    .describe(
      'The reference file name to read, exactly as listed in the system prompt or other tool instructions. Passing any other value returns an error.'
    ),
});

export type ReadReferenceFileArguments = z.infer<typeof argumentZod>;

export const readReferenceFileManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Read reference file',
  prettyStatus: {
    executing: 'Reading reference file...',
    executed: 'Read reference file',
    failed: 'Failed to read reference file',
  },
  prettyErrors: {
    fallback: 'Unable to read reference file',
    patterns: [
      {
        match: 'not found',
        message: 'Reference file not found',
      },
    ],
  },
  llmTool: {
    name: toolName,
    description: dedent`
      Reads a reference document that describes the assistant's capabilities and limitations, or explains how to work with Webflow features that have special handling requirements.

      Use this tool to:
      - Confirm whether a user request is something you can fulfill before attempting it.
      - Look up guidance for features the system prompt flags as needing extra instructions (e.g. components, CMS-bound elements).

      Pass a name exactly as it appears in the reference index in the system prompt. Returns the full text of the document.
    `,
    inputSchema: argumentZod,
  },
  type: 'server',
  confirmBeforeExecuting: false,
});
